import type { Stat } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export const vehicleValue = {
  getMakes,
  getModels,
  getYears,
  getTrims,
  search,
}

async function getMakes(): Promise<string[]> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/stat/vehicle-value/makes`, {
      method: 'GET',
      headers,
      next: { revalidate: 1000 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function getModels(make: string): Promise<string[]> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/stat/vehicle-value/models?make=${make}`, {
      method: 'GET',
      headers,
      next: { revalidate: 1000 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function getYears(make: string, model: string): Promise<string[]> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/stat/vehicle-value/years?make=${make}&model=${model}`, {
      method: 'GET',
      headers,
      next: { revalidate: 1000 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function getTrims(make: string, model: string, year: string | number): Promise<string[]> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/stat/vehicle-value/trims?make=${make}&model=${model}&year=${year}`, {
      method: 'GET',
      headers,
      next: { revalidate: 1000 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function search(params: object): Promise<Stat.VehicleValue[]> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/stat/vehicle-value/search?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers,
      next: { revalidate: 1000 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
